export default function makeRequired(field: string, touched: any, values: any, errors: any) {
	if (touched[field] && !values[field]) {
		errors[field] = 'Required';
	}
}
